import React from "react";
import { Grid, TextField, IconButton, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import { updateExternalInfo, removeExternalInfo } from "features/OrgAdmin/orgAdminSlice";

export default function ExternalInfoRow({ index, data }) {
  const dispatch = useDispatch();

  const handleChange = (field, value) => {
    dispatch(updateExternalInfo({ index, field, value }));
  };

  const handleRemove = () => {
    dispatch(removeExternalInfo(index));
  };

  const fieldOptions = [
    "Journeys Api",
    "Geofence Api",
    "ETA Api",
    "Attendance Api",
    "Vendor Api Key",
    "Migrate Journeys Api",
    "Update Vehicle Api",
  ];

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      sx={{
        mb: 1,
        p: 1,
        borderRadius: 1,
        bgcolor: "#f9fafc",
        fontSize: "0.65rem",
      }}
    >
      <Grid item xs={5}>
        <FormControl fullWidth size="small" sx={{ fontSize: "0.65rem" }}>
          <InputLabel sx={{ fontSize: "0.65rem" }}>Field</InputLabel>
          <Select
            value={data.key || ""}
            label="Field"
            onChange={(e) => handleChange("key", e.target.value)}
            sx={{ fontSize: "0.65rem" }}
          >
            {fieldOptions.map((option) => (
              <MenuItem key={option} value={option} sx={{ fontSize: "0.65rem" }}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={5}>
        <TextField
          fullWidth
          size="small"
          label="Value"
          value={data.value}
          onChange={(e) => handleChange("value", e.target.value)}
          InputLabelProps={{ style: { fontSize: "0.8rem" } }}
          InputProps={{ style: { fontSize: "0.8rem" } }}
        />
      </Grid>
      <Grid item xs={2} sx={{ display: "flex", justifyContent: "center" }}>
        <IconButton onClick={handleRemove} color="error" size="small">
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Grid>
    </Grid>
  );
}
